import React, { useState } from 'react'
import { Input, Button, Modal, Form } from 'antd'
import PropTypes from 'prop-types'

const AddColumnModal = ({ handleCreate, handleCancel, showModal }) => {
	const [title, setTitle] = useState('')
	// todo: add data type
	return (
		<Modal
			open={showModal}
			onCancel={handleCancel}
			title="Nova coluna"
			footer={[
				<Button
					key="cancelar"
					onClick={() => {
						handleCancel()
						setTitle('')
					}}>
					Cancelar
				</Button>,
				<Button
					type="primary"
					key="criar"
					onClick={() => {
						handleCreate(title)
						setTitle('')
					}}
					disabled={!title}>
					Adicionar
				</Button>,
			]}>
			<Form.Item label="Nome">
				<Input
					autoFocus
					value={title}
					onChange={(e) => setTitle(e.target.value)}
				/>
			</Form.Item>
		</Modal>
	)
}

AddColumnModal.propTypes = {
	handleCreate: PropTypes.func,
	handleCancel: PropTypes.func,
	showModal: PropTypes.bool,
}

export default AddColumnModal
